module.exports = __webpack_public_path__ + "73a4c217dd482111959b6a2e2dc495c3.svg";